import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexBanksRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/banks', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const exportBankRequest = ({
  dispatch,
  format = '.xlsx',
  responseType = 'text',
  params = {},
  callback,
  successCallback
}) =>
  ApiService.request('get', `/banks/export${format}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });

export const debounceIndexBanksRequest = AwesomeDebouncePromise(indexBanksRequest, 300);
